export default __webpack_public_path__ + "static/hero-kickstart-38d93af5d52decc13611aca8a5a9aae1.jpg";